import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
/**
 * セミナー一覧を表示するためのコンポーネント
 * @param props
 * @constructor
 */
export const SeminarCliList = (props) => {
    const { children, className = '' } = props;
    return (_jsx("div", Object.assign({ className: clsx('flex flex-col gap-y-32', className) }, { children: children })));
};
